import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Box } from '@gemini/core';
import ErrorBoundary from '@/components/ErrorBoundary/ErrorBoundary';
import MapComponent from '@/components/Map/Map';
import { MapErrorContent } from '@/components/MapErrorContent';
import Sidebar from '@/components/Sidebar';
import { useMobileViewDetect } from '@/hooks/useMobileViewDetect/useMobileViewDetect';
export function ShellLayout() {
    const { isMobileView } = useMobileViewDetect();
    const [mainSize, setMainSize] = useState(0);
    const mainRef = useRef(null);
    useEffect(() => {
        const getSizeMainView = () => {
            if (mainRef.current) {
                const rect = mainRef.current.getBoundingClientRect();
                rect.top < 0
                    ? setMainSize(window.innerHeight)
                    : setMainSize(window.innerHeight - rect.top);
            }
        };
        getSizeMainView();
        window.addEventListener('resize', getSizeMainView);
        window.addEventListener('scroll', getSizeMainView);
        return () => {
            window.removeEventListener('resize', getSizeMainView);
            window.removeEventListener('scroll', getSizeMainView);
        };
    }, []);
    return (_jsx(Box, { as: "main", ref: mainRef, zIndex: "zIndex.1", position: "relative", children: _jsx(Box, { display: {
                'breakpoint.xs': 'block',
                'breakpoint.sm': 'flex',
            }, flexWrap: "nowrap", flexDirection: "row", children: _jsxs(_Fragment, { children: [_jsx(Sidebar, {}), !isMobileView ? (_jsx(Box, { as: "div", flex: "1", id: "map-container", height: mainSize, position: "sticky", top: "0", children: _jsx(ErrorBoundary, { fallbackComponent: _jsx(MapErrorContent, {}), children: _jsx(MapComponent, {}) }) })) : undefined] }) }) }));
}
